function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadius(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98
    },
    fill: "#000000",
    d: "M 155.5,63.5 C 191.168,63.3333 226.835,63.5 262.5,64C 272.389,67.4265 277.389,74.4265 277.5,85C 276.989,95.8262 271.656,102.826 261.5,106C 228.833,106.333 196.167,106.667 163.5,107C 142.36,109.821 126.193,120.321 115,138.5C 111.48,144.394 109.146,150.727 108,157.5C 106.708,192.133 106.041,226.8 106,261.5C 101.927,273.632 93.4266,278.798 80.5,277C 71.8858,275.72 66.3858,270.886 64,262.5C 63.3333,226.833 63.3333,191.167 64,155.5C 66.5475,137.416 73.2142,121.082 84,106.5C 102.203,82.8146 126.037,68.4813 155.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.951
    },
    fill: "#000000",
    d: "M 333.5,63.5 C 356.264,61.7641 365.431,72.0974 361,94.5C 355.167,104.854 346.334,108.688 334.5,106C 320.149,99.995 315.649,89.495 321,74.5C 323.708,69.0793 327.875,65.4127 333.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.951
    },
    fill: "#000000",
    d: "M 418.5,63.5 C 440.652,60.8179 450.152,70.4845 447,92.5C 440.597,105.421 430.43,109.588 416.5,105C 408.159,100.99 404.159,94.3236 404.5,85C 404.306,74.5298 408.973,67.3632 418.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.951
    },
    fill: "#000000",
    d: "M 420.5,148.5 C 441.022,147.521 449.856,157.188 447,177.5C 443.515,187.302 436.515,191.968 426,191.5C 412.215,191.049 405.049,183.882 404.5,170C 404.391,158.628 409.725,151.462 420.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.947
    },
    fill: "#000000",
    d: "M 421.5,233.5 C 443.365,233.542 451.532,244.209 446,265.5C 440.671,275.067 432.504,278.901 421.5,277C 409.995,274.504 404.328,267.337 404.5,255.5C 404.438,243.582 410.105,236.248 421.5,233.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.951
    },
    fill: "#000000",
    d: "M 77.5,319.5 C 100.264,317.764 109.431,328.097 105,350.5C 99.1671,360.854 90.3338,364.688 78.5,362C 64.1492,355.995 59.6492,345.495 65,330.5C 67.708,325.079 71.8747,321.413 77.5,319.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.951
    },
    fill: "#000000",
    d: "M 418.5,319.5 C 440.652,316.818 450.152,326.485 447,348.5C 440.597,361.421 430.43,365.588 416.5,361C 408.159,356.99 404.159,350.324 404.5,341C 404.306,330.53 408.973,323.363 418.5,319.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.951
    },
    fill: "#000000",
    d: "M 78.5,404.5 C 100.838,403.336 109.672,413.669 105,435.5C 97.9318,447.409 87.7652,450.909 74.5,446C 69.0109,443.532 65.5109,439.365 64,433.5C 60.4116,419.352 65.245,409.685 78.5,404.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.951
    },
    fill: "#000000",
    d: "M 164.5,404.5 C 185.022,403.521 193.856,413.188 191,433.5C 187.515,443.302 180.515,447.968 170,447.5C 156.215,447.049 149.049,439.882 148.5,426C 148.391,414.628 153.725,407.462 164.5,404.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.947
    },
    fill: "#000000",
    d: "M 249.5,404.5 C 266.224,402.336 275.557,409.503 277.5,426C 275.649,443.449 265.982,450.449 248.5,447C 238.611,443.573 233.611,436.573 233.5,426C 234.161,415.116 239.494,407.95 249.5,404.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.951
    },
    fill: "#000000",
    d: "M 334.5,404.5 C 356.838,403.336 365.672,413.669 361,435.5C 353.932,447.409 343.765,450.909 330.5,446C 325.011,443.532 321.511,439.365 320,433.5C 316.412,419.352 321.245,409.685 334.5,404.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.951
    },
    fill: "#000000",
    d: "M 420.5,404.5 C 441.022,403.521 449.856,413.188 447,433.5C 443.515,443.302 436.515,447.968 426,447.5C 412.215,447.049 405.049,439.882 404.5,426C 404.391,414.628 409.725,407.462 420.5,404.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadius);
export default __webpack_public_path__ + "static/media/radius.625ea7cade67ee3bb198159749b3ca49.svg";
export { ForwardRef as ReactComponent };